import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import AppContainer from './AppContainer';
import RCTAccuracyPracticeContainer from './rct/accuracy/pages/practice/RCTAccuracyPracticeContainer';
import RCTAccuracyOpeningContainer from './rct/accuracy/pages/opening/RCTAccuracyOpeningContainer';
import RCTAccuracyQuestionsContainer from './rct/accuracy/pages/questions/RCTAccuracyQuestionsContainer';
import RCTAccuracyModelContainer from './rct/accuracy/pages/model/RCTAccuracyModelContainer';
import RCTAccuracyCountdownContainer from './rct/accuracy/pages/countdown/RCTAccuracyCountdownContainer';
import RCTFluencyPassageContainer from './rct/fluency/pages/passage/RCTFluencyPassageContainer';
import RCTFluencyModelContainer from './rct/fluency/pages/model/RCTFluencyModelContainer';
import RCTFluencyCountdownContainer from './rct/fluency/pages/countdown/RCTFluencyCountdownContainer';
import RCTFluencyPracticeContainer from './rct/fluency/pages/practice/RCTFluencyPracticeContainer';
import InterstitialContainer from './common/interstitial/InterstitialContainer';
import StartContainer from './common/start/startContainer';
import RCTComprehensionQuestionsContainer from './rct/comprehension/pages/questions/RCTComprehensionQuestionsContainer';
import DazePassageContainer from './daze/pages/passage/DazePassageContainer';
import DazeModelScrollContainer from './daze/pages/modelScroll/DazeModelScrollContainer';
import DazeModelContainer from './daze/pages/model/DazeModelContainer';
import DazePracticeContainer from './daze/pages/practice/DazePracticeContainer';
import DazeInstructionsContainer from './daze/pages/instructions/DazeInstructionsContainer';
import DazeCountdownContainer from './daze/pages/countdown/DazeCountdownContainer';
import TRCBookStartContainer from './trc/pages/bookstart/TRCBookStartContainer';
import TROInstructionsContainer from './trc/pages/instructions/TROInstructionsContainer';
import TRORemindersContainer from './trc/pages/reminders/TRORemindersContainer';
import TRCCountdownContainer from './trc/pages/countdown/TRCCountdownContainer';
import TRCReadingContainer from './trc/pages/reading/TRCReadingContainer';
import TRCQuestionsContainer from './trc/pages/questions/TRCQuestionsContainer';
import VocabTQVMPracticeContainer from './vocab/tqvm/pages/practice/VocabTQVMPracticeContainer';
import VocabTQVMCountdownContainer from './vocab/tqvm/pages/countdown/VocabTQVMCountdownContainer';
import VocabTQVMQuestionContainer from './vocab/tqvm/pages/questions/VocabTQVMQuestionsContainer';
import VocabFITBPracticeContainer from './vocab/fitb/pages/practice/VocabFITBPracticeContainer';
import VocabFITBCountdownContainer from './vocab/fitb/pages/countdown/VocabFITBCountdownContainer';
import VocabFITBQuestionContainer from './vocab/fitb/pages/questions/VocabFITBQuestionsContainer';
import VocabBDPracticeContainer from './vocab/bd/pages/practice/VocabBDPracticeContainer';
import VocabBDCountdownContainer from './vocab/bd/pages/countdown/VocabBDCountdownContainer';
import VocabBDQuestionsContainer from './vocab/bd/pages/questions/VocabBDQuestionsContainer';
import SpellingPracticeContainer from './spelling/pages/practice/SpellingPracticeContainer';
import SpellingCountdownContainer from './spelling/pages/countdown/SpellingCountdownContainer';
import SpellingQuestionsContainer from './spelling/pages/questions/SpellingQuestionsContainer';
import RANPracticeContainer from './ran/RANPracticeContainer';
import RANCountdownContainer from './ran/RANCountdownContainer';
import RANItemsContainer from './ran/RANItemsContainer';
import RANDirectionsContainer from './ran/RANDirectionsContainer';
import LCReadingContainer from './lc/pages/reading/LCReadingContainer';
import LNPracticeContainer from './ln/pages/practice/LNPracticeContainer';
import LNCountdownContainer from './ln/pages/countdown/LNCountdownContainer';
import LNQuestionsContainer from './ln/pages/questions/LNQuestionsContainer';
import IPSPracticeContainer from './ips/pages/practice/IPSPracticeContainer';
import IPSCountdownContainer from './ips/pages/countdown/IPSCountdownContainer';
import IPSQuestionsContainer from './ips/pages/questions/IPSQuestionsContainer';
import NWPracticeContainer from './nw/pages/practice/NWPracticeContainer';
import NWCountdownContainer from './nw/pages/countdown/NWCountdownContainer';
import NWQuestionsContainer from './nw/pages/questions/NWQuestionsContainer';
import PBPracticeContainer from './pb/pages/practice/PBPracticeContainer';
import PBCountdownContainer from './pb/pages/countdown/PBCountdownContainer';
import PBQuestionsContainer from './pb/pages/questions/PBQuestionsContainer';
import MazePassageContainer from './maze/pages/passage/MazePassageContainer';
import MazeModelScrollContainer from './maze/pages/modelScroll/MazeModelScrollContainer';
import MazeModelContainer from './maze/pages/model/MazeModelContainer';
import MazePracticeContainer from './maze/pages/practice/MazePracticeContainer';
import MazeInstructionsContainer from './maze/pages/instructions/MazeInstructionsContainer';
import MazeCountdownContainer from './maze/pages/countdown/MazeCountdownContainer';
import LCQuestionsContainer from './lc/pages/questions/LCQuestionsContainer';

import MazeFlowStrategy from './maze/mazeFlowStrategy';
import CLPLFlowStrategy from './clpl/CLPLFlowStrategy';

// Word Reading
import WROpeningContainer from './wr/pages/opening/WROpeningContainer';
import WRModelContainer from './wr/pages/model/WRModelContainer';
import WRPracticeContainer from './wr/pages/practice/WRPracticeContainer';
import WRCountdownContainer from './wr/pages/countdown/WRCountdownContainer';
import WRQuestionsContainer from './wr/pages/questions/WRQuestionsContainer';

import {
    STUDENT_ASSESSMENT,
    START,
    DONE,
    INTERSTITIAL,
    DAZE_COUNTDOWN,
    RCT_OPENING,
    RCT_FLUENCY_PASSAGE,
    DAZE_PASSAGE,
    DAZE_MODEL,
    DAZE_PRACTICE,
    DAZE_MODEL_SCROLL,
    RCT_ACCURACY_PRACTICE,
    RCT_FLUENCY_MODEL,
    RCT_FLUENCY_PRACTICE,
    RCT_FLUENCY_COUNTDOWN,
    RCT_ACCURACY_QUESTIONS,
    RCT_ACCURACY_MODEL,
    RCT_ACCURACY_COUNTDOWN,
    RCT_COMPREHENSION_PASSAGE,
    TRC_COUNTDOWN,
    TRC_READING,
    TRC_QUESTIONS,
    TRO_INSTRUCTIONS,
    TRO_REMINDERS,
    TRC_BOOK_START,
    DAZE_INSTRUCTIONS,
    VOCAB_TQVM_PRACTICE,
    VOCAB_TQVM_COUNTDOWN,
    VOCAB_TQVM_QUESTIONS,
    VOCAB_FITB_PRACTICE,
    VOCAB_FITB_COUNTDOWN,
    VOCAB_FITB_QUESTIONS,
    VOCAB_BD_PRACTICE,
    VOCAB_BD_COUNTDOWN,
    VOCAB_BD_QUESTIONS,
    SPELLING_PRACTICE,
    SPELLING_COUNTDOWN,
    SPELLING_QUESTIONS,
    RAN_NUMBERS_PRACTICE,
    RAN_NUMBERS_COUNTDOWN,
    RAN_NUMBERS_ITEMS,
    RAN_NUMBERS_DIRECTIONS,
    LC_READING,
    LN_PRACTICE,
    LN_COUNTDOWN,
    LN_QUESTIONS,
    IPS_PRACTICE,
    IPS_COUNTDOWN,
    IPS_QUESTIONS,
    NW_PRACTICE,
    NW_COUNTDOWN,
    NW_QUESTIONS,
    PB_PRACTICE,
    PB_COUNTDOWN,
    PB_QUESTIONS,
    ANY_PATH,
    MAZE_PASSAGE,
    MAZE_MODEL_SCROLL,
    MAZE_MODEL,
    MAZE_PRACTICE,
    MAZE_INSTRUCTIONS,
    MAZE_COUNTDOWN,
    WR_OPENING,
    WR_MODEL,
    WR_PRACTICE,
    WR_COUNTDOWN,
    WR_QUESTIONS,
    LC_QUESTIONS,
    OWLY_INTERSTITIAL,
    CLPL_PASSAGE,
    CLPL_MODEL_SCROLL,
    CLPL_MODEL,
    CLPL_PRACTICE,
    CLPL_INSTRUCTIONS,
    CLPL_COUNTDOWN,
} from './constants/url';
import OwlyInterstitialContainer from './common/owlyInterstitial/OwlyInterstitialContainer';

const getComponentWithProps = (Component, extraProps) => (props) => <Component {...props} {...extraProps} />;

const routes = [
    {
        path: START,
        component: StartContainer,
    },
    {
        path: DONE,
        component: StartContainer,
    },
    {
        path: INTERSTITIAL,
        component: InterstitialContainer,
    },
    {
        path: OWLY_INTERSTITIAL,
        component: OwlyInterstitialContainer,
    },
    // RCT
    {
        path: RCT_OPENING,
        component: RCTAccuracyOpeningContainer,
    },
    {
        path: RCT_ACCURACY_PRACTICE,
        component: RCTAccuracyPracticeContainer,
    },
    {
        path: RCT_ACCURACY_MODEL,
        component: RCTAccuracyModelContainer,
    },
    {
        path: RCT_ACCURACY_COUNTDOWN,
        component: RCTAccuracyCountdownContainer,
    },
    {
        path: RCT_ACCURACY_QUESTIONS,
        component: RCTAccuracyQuestionsContainer,
    },
    {
        path: RCT_FLUENCY_COUNTDOWN,
        component: RCTFluencyCountdownContainer,
    },
    {
        path: RCT_FLUENCY_MODEL,
        component: RCTFluencyModelContainer,
    },
    {
        path: RCT_FLUENCY_PRACTICE,
        component: RCTFluencyPracticeContainer,
    },
    {
        path: RCT_FLUENCY_PASSAGE,
        component: RCTFluencyPassageContainer,
    },
    {
        path: RCT_COMPREHENSION_PASSAGE,
        component: RCTComprehensionQuestionsContainer,
    },
    // Word Reading
    {
        path: WR_OPENING,
        component: WROpeningContainer,
    },
    {
        path: WR_MODEL,
        component: WRModelContainer,
    },
    {
        path: WR_PRACTICE,
        component: WRPracticeContainer,
    },
    {
        path: WR_COUNTDOWN,
        component: WRCountdownContainer,
    },
    {
        path: WR_QUESTIONS,
        component: WRQuestionsContainer,
    },
    // DAZE
    {
        path: DAZE_PASSAGE,
        component: DazePassageContainer,
    },
    {
        path: DAZE_MODEL_SCROLL,
        component: DazeModelScrollContainer,
    },
    {
        path: DAZE_MODEL,
        component: DazeModelContainer,
    },
    {
        path: DAZE_PRACTICE,
        component: DazePracticeContainer,
    },
    {
        path: DAZE_INSTRUCTIONS,
        component: DazeInstructionsContainer,
    },
    {
        path: DAZE_COUNTDOWN,
        component: DazeCountdownContainer,
    },
    // MAZE
    {
        path: MAZE_PASSAGE,
        component: getComponentWithProps(MazePassageContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    {
        path: MAZE_MODEL_SCROLL,
        component: getComponentWithProps(MazeModelScrollContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    {
        path: MAZE_MODEL,
        component: getComponentWithProps(MazeModelContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    {
        path: MAZE_PRACTICE,
        component: getComponentWithProps(MazePracticeContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    {
        path: MAZE_INSTRUCTIONS,
        component: getComponentWithProps(MazeInstructionsContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    {
        path: MAZE_COUNTDOWN,
        component: getComponentWithProps(MazeCountdownContainer, {flowStrategy: MazeFlowStrategy, isExtendedView: true}),
    },
    // Cual Palabra
    {
        path: CLPL_PASSAGE,
        component: getComponentWithProps(MazePassageContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    {
        path: CLPL_MODEL_SCROLL,
        component: getComponentWithProps(MazeModelScrollContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    {
        path: CLPL_MODEL,
        component: getComponentWithProps(MazeModelContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    {
        path: CLPL_PRACTICE,
        component: getComponentWithProps(MazePracticeContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    {
        path: CLPL_INSTRUCTIONS,
        component: getComponentWithProps(MazeInstructionsContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    {
        path: CLPL_COUNTDOWN,
        component: getComponentWithProps(MazeCountdownContainer, {flowStrategy: CLPLFlowStrategy}),
    },
    // TRC
    {
        path: TRO_INSTRUCTIONS,
        component: TROInstructionsContainer,
    },
    {
        path: TRO_REMINDERS,
        component: TRORemindersContainer,
    },
    {
        path: TRC_BOOK_START,
        component: TRCBookStartContainer,
    },
    {
        path: TRC_COUNTDOWN,
        component: TRCCountdownContainer,
    },
    {
        path: TRC_READING,
        component: TRCReadingContainer,
    },
    {
        path: TRC_QUESTIONS,
        component: TRCQuestionsContainer,
    },
    // VOCAB
    {
        path: VOCAB_TQVM_PRACTICE,
        component: VocabTQVMPracticeContainer,
    },
    {
        path: VOCAB_TQVM_COUNTDOWN,
        component: VocabTQVMCountdownContainer,
    },
    {
        path: VOCAB_TQVM_QUESTIONS,
        component: VocabTQVMQuestionContainer,
    },
    {
        path: VOCAB_FITB_PRACTICE,
        component: VocabFITBPracticeContainer,
    },
    {
        path: VOCAB_FITB_COUNTDOWN,
        component: VocabFITBCountdownContainer,
    },
    {
        path: VOCAB_FITB_QUESTIONS,
        component: VocabFITBQuestionContainer,
    },
    {
        path: VOCAB_BD_PRACTICE,
        component: VocabBDPracticeContainer,
    },
    {
        path: VOCAB_BD_COUNTDOWN,
        component: VocabBDCountdownContainer,
    },
    {
        path: VOCAB_BD_QUESTIONS,
        component: VocabBDQuestionsContainer,
    },
    // SPELLING
    {
        path: SPELLING_PRACTICE,
        component: SpellingPracticeContainer,
    },
    {
        path: SPELLING_COUNTDOWN,
        component: SpellingCountdownContainer,
    },
    {
        path: SPELLING_QUESTIONS,
        component: SpellingQuestionsContainer,
    },
    // RAN
    {
        path: RAN_NUMBERS_DIRECTIONS,
        component: RANDirectionsContainer,
    },
    {
        path: RAN_NUMBERS_PRACTICE,
        component: RANPracticeContainer,
    },
    {
        path: RAN_NUMBERS_COUNTDOWN,
        component: RANCountdownContainer,
    },
    {
        path: RAN_NUMBERS_ITEMS,
        component: RANItemsContainer,
    },
    // LC
    {
        path: LC_READING,
        component: LCReadingContainer,
    },
    // LN
    {
        path: LN_PRACTICE,
        component: LNPracticeContainer,
    },
    {
        path: LN_COUNTDOWN,
        component: LNCountdownContainer,
    },
    {
        path: LN_QUESTIONS,
        component: LNQuestionsContainer,
    },
    // IPS
    {
        path: IPS_PRACTICE,
        component: IPSPracticeContainer,
    },
    {
        path: IPS_COUNTDOWN,
        component: IPSCountdownContainer,
    },
    {
        path: IPS_QUESTIONS,
        component: IPSQuestionsContainer,
    },
    // NW
    {
        path: NW_PRACTICE,
        component: NWPracticeContainer,
    },
    {
        path: NW_COUNTDOWN,
        component: NWCountdownContainer,
    },
    {
        path: NW_QUESTIONS,
        component: NWQuestionsContainer,
    },
    // PB
    {
        path: PB_PRACTICE,
        component: PBPracticeContainer,
    },
    {
        path: PB_COUNTDOWN,
        component: PBCountdownContainer,
    },
    {
        path: PB_QUESTIONS,
        component: PBQuestionsContainer,
    },
    // LC
    {
        path: LC_QUESTIONS,
        component: LCQuestionsContainer,
    },
];

const routeComponents = routes.map(({ path, component }) => (
    <Route
        path={path}
        component={component}
        key={path.replace('/', '_')}
    />
));

export default  (
    <AppContainer>
        <Switch>
            {routeComponents}
            <Route exact path={STUDENT_ASSESSMENT} component={StartContainer} />
            <Redirect from={ANY_PATH} to={STUDENT_ASSESSMENT} />
        </Switch>
    </AppContainer>
);
